import  { useState,useEffect  } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom"; // useNavigate for redirection
import Header from "../../component/Header";
import { useSwal } from "../../component/sweetalert";
import api from "../../Services/api"; // Import Axios instance
import "../AddBlog/index.css";
export default function AddTallyAddons() {
  const [tally, setTally] = useState("");  
   const [tallyUrl, setTallyUrl] = useState("");
  const [iconFile, setIconFile] = useState(null);
const [blogOptions, setBlogOptions] = useState([]);
const [loading, setLoading] = useState(false);
  const navigate = useNavigate(); // Hook for navigation
 const alert = useSwal();
  
  // Handle form submission
useEffect(() => {
  const fetchBlogs = async () => {
    try {
      const response = await api.post("/AllBlogView");
      setBlogOptions(response.data);
    } catch (error) {
      console.error("Error fetching blog options:", error);
    }
  };

  fetchBlogs();
}, []);
  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("tally", tally);
      formData.append("Tally_Url", tallyUrl);
      if (iconFile) {
        formData.append("Tally_Icon", iconFile);
      }

      const response = await api.post("/insertTallyAddon", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.data) {
        alert("success", "Tally addon added successfully!");
        navigate("/tally-addons");
      }
    } catch (err) {
      console.error("Upload error:", err);
      alert("error", "Something went wrong!");     
    }finally {
        setLoading(false);
      }
  };
const blogOptionsFormatted = blogOptions.map((blog) => ({
  value: blog.view_url,
  label: blog.heading,
}));

const handleBlogSelect = (selectedOption) => {
  setTallyUrl(selectedOption?.value || "");
};

  return (
    <section className="dashboardpage">
      <Header pageTitle="Add Our Plug & Play Module Details" backTo="/tally-addons" />
      <div className="pageLeftspace">
                <div className="d-flex justify-content-start col-xl-6 col-12">
        {/* Form Section */}
        <form className="form-fields d-flex" onSubmit={handleSubmit}>
          <div className="grid-container ">
            <div className="input-container">
              <input
                type="text"
                id="name"
                placeholder="Enter Tally Addon"
                value={tally}
                onChange={(e) => setTally(e.target.value)}
                required
              />
              {/* <label htmlFor="name">Add Tally Addon</label> */}
              <span className="underline"></span>
            </div>
 <div className="input-container file-input-container">
                <input
                  type="file"
                  id="fileUpload"
                  accept="image/*"
                  onChange={(e) => setIconFile(e.target.files[0])}
                  required
                />
                <span className="underline"></span>
              </div>
               <div className="input-container">
              <Select
                options={blogOptionsFormatted}
                value={blogOptionsFormatted.find((opt) => opt.value === tallyUrl)}
                onChange={handleBlogSelect}
                placeholder="Select Blog"
                isClearable
                // menuIsOpen= {true}
              />

              </div>
              <button className="btn btn-purpal" type="submit" disabled={loading}>
                {loading ? "Submiting..." : "Submit"}
              </button>       
          </div>
        </form>
      </div>
      </div>
    </section>
  );
}
